import axios from 'axios';
import LocalStorageManager from '@component_path/lib/localStorageManager';
import AxiosWorker from '@component_path/lib/axiosWorker';
import { captureException } from '@sentry/browser';
import indexedDbManager from '@component_path/lib/indexedDbManager';

export default {
  async setAllMasterData(){
    await indexedDbManager.checkExpiredTables();
    indexedDbManager.masterUrls().map(url => {
      this.setMasterData(url);
    });
  },
  setMasterData(url){
    indexedDbManager.isExistsData(url).then((exists) => {
      if (!exists) {
        AxiosWorker.getApi(url, (data) => {
          this.setIndexedDbData(url, data);
        });
      }
    });
  },
  async setIndexedDbData(url, data) {
    await indexedDbManager.addDataList(url, Object.values(data));
  },
  setMasterDataWithoutWorker(url, callback = () => {}){
    // 速度改善のために追加した処理で、
    // 当初はこの箇所で取得するデータが変わることを想定していなかった。
    //if (LocalStorageManager.getStorage(url)) return;

    axios.get(url)
      .then(res => {
        try{
          LocalStorageManager.setStorage(url, res.data);
          callback(LocalStorageManager.getStorage(url));
        }catch(err){
          captureException(err);
        }
      })
      .catch(() => {
        alert('ネットワークの状態が不安定です。\n通信回線の良い状況で再度アクセスしてください');
      });
  }
}
